export const CONSTANTS = {
  ORIGINAL_ADDRESS: $localize`Original Address`,
};
